import { HttpClient } from "@angular/common/http";
import { environment } from "#environments/environment";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { P6Instance } from "#models/site-primavera";

@Injectable({
  providedIn: "root",
})
export class P6Service {
  private currentSiteId$ = new BehaviorSubject<number>(0);
  constructor(private readonly _http: HttpClient) {}

  getPhases(): Observable<Array<IActivityCode>> {
    return this._http.get<Array<IActivityCode>>(
      `${environment.apiEndpoint}/phases`
    );
  }

  getMilestones(): Observable<Array<IActivityCode>> {
    return this._http.get<Array<IActivityCode>>(
      `${environment.apiEndpoint}/milestone-types`
    );
  }

  getExecutionActivities(): Observable<Array<IActivityCode>> {
    return this._http.get<Array<IActivityCode>>(
      `${environment.apiEndpoint}/execution-activity-types`
    );
  }

  getProjectTypes(): Observable<Array<IActivityCode>> {
    return this._http.get<Array<IActivityCode>>(
      `${environment.apiEndpoint}/project-types`
    );
  }

  getCalendars(): Observable<Array<IActivityCode>> {
    return this._http.get<Array<IActivityCode>>(
      `${environment.apiEndpoint}/calendar`
    );
  }

  getWbsCategories(): Observable<Array<{ ID: string; Name: string }>> {
    return this._http.get<Array<{ ID: string; Name: string }>>(
      `${environment.apiEndpoint}/wbs-categories`
    );
  }

  getTAW(): Observable<Array<IActivityCode>> {
    return this._http.get<Array<IActivityCode>>(
      `${environment.apiEndpoint}/turnaround-additional-works`
    );
  }
  setCurrentSite(siteId: number) {
    this.currentSiteId$.next(siteId);
  }
  getCurrentSite() {
    return this.currentSiteId$.asObservable();
  }

  getP6Instances(): Observable<Array<P6Instance>> {
    return this._http.get<Array<P6Instance>>(
      `${environment.apiEndpoint}/p6-instance`
    );
  }

  createP6Instance(p6Instance: P6Instance): Observable<P6Instance> {
    return this._http.post<P6Instance>(
      `${environment.apiEndpoint}/p6-instance`,
      p6Instance
    );
  }

  getP6InstanceBySiteID(siteID: number): Observable<P6Instance> {
    return this._http.get<P6Instance>(
      `${environment.apiEndpoint}/p6-instance/site/${siteID}`
    );
  }
}

export interface IActivityCode {
  Code: string;
  Description: string;
  ID: string;
  SiteId: number;
}
